<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <span
    data-slot="color-key-value"
    :class="cn('line-clamp-2 font-semibold group-data-[layout=hero]/color-key:text-kpi-2xl', props.class)"
  >
    <slot />
  </span>
</template>
